import {UIGameResponsiveController} from '../../../shared/scripts/ui_game/UIGameResponsiveController'
import {UIMGameManager} from './UIMGameManager'

export class UIMGameResponsiveController extends UIGameResponsiveController {
    constructor(uiGameManager: UIMGameManager) {
        super(uiGameManager)
        UIGameResponsiveController.resolutionScale = 2
    }

    // eslint-disable-next-line class-methods-use-this
    protected showVerticalAds(): boolean {
        return false
    }

    // eslint-disable-next-line class-methods-use-this
    protected showHorizontalAds(): boolean {
        return false
    }

    getScaleForRotation(): number {
        return window.innerWidth / this.uiGameManager.canvasController.appW
    }

    // eslint-disable-next-line class-methods-use-this
    getAppWnH(): {w: number, h: number} {
        const w = window.innerWidth
        const h = UIMGameResponsiveController.getWindowHeightWithIOS26Fix()

        return {w: w, h: h}
    }

    // Since iOS 26, window.innerHeight does not always reflect the actual height of the window when the window.resize event is triggered.
    // This function is a workaround because body.clientHeight is somehow always correct
    private static getWindowHeightWithIOS26Fix(): number {
        return document.body.clientHeight
    }

    // eslint-disable-next-line class-methods-use-this
    getCanvasY(): number {
        return 0
    }

    // eslint-disable-next-line class-methods-use-this
    getCanvasX(): number {
        return 0
    }

    buildRenderer() {
        const size = this.getAppWnH()
        this.uiGameManager.canvasController.app.renderer.resize(size.w, size.h)
        this.uiGameManager.canvasController.app.view.style.top = '0%'
    }
}
